<div class="yc-toast yc-toast-error">

  <i class="ri-close-circle-fill icon"></i>

  <div>
    <p class="body-medium" *ngIf="!options.enableHtml">{{title}}</p>
    <p class="body-medium" *ngIf="options.enableHtml" [innerHTML]="title | htmlSanitizer"></p>
    <a class="bodylink-medium">{{message}}</a>
  </div>

  <i *ngIf="options.closeButton" class="ri-close-fill close"></i>
</div>